/**
 * Formats tag collection names, replacing "/" with "." at the beginning
 * @param {string} name - The collection name
 * @returns {string} - The formatted collection name
 */
export const formatTagName = (name) => {
  if (name && name.startsWith('/')) {
    return name.replace('/', '.');
  }
  return name;
}; 